module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/series/fr-FR/img_series-105.png";